import { bind, play, setEnabled } from "cuelume"

const INTERACTION_SOUNDS_STORAGE_KEY = "optimist-portal-interaction-sounds"

export function getInteractionSoundsEnabled(): boolean {
	try {
		return window.localStorage.getItem(INTERACTION_SOUNDS_STORAGE_KEY) !== "false"
	} catch (error) {
		console.warn("[Portal] Unable to read the interaction sound preference", error)
		return true
	}
}

export function initializeInteractionSounds(): void {
	setEnabled(getInteractionSoundsEnabled())
	bind()
}

export function setInteractionSoundsEnabled(enabled: boolean): void {
	if (enabled) {
		setEnabled(true)
		play("toggle")
	} else {
		play("toggle")
		setEnabled(false)
	}

	try {
		window.localStorage.setItem(INTERACTION_SOUNDS_STORAGE_KEY, String(enabled))
	} catch (error) {
		console.warn("[Portal] Unable to save the interaction sound preference", error)
	}
}
